import type { ScheduledJob } from "../../services/use-scheduled-jobs"

export function scheduleJobStatus(job: ScheduledJob) {
  if (!job.enabled || job.manualOnly) {
    return "paused"
  }
  return job.runSummary.latestFailure ? "failing" : "active"
}
const STATUS = {
  paused: { label: "Paused", className: "status c-muted" },
  failing: { label: "Failing", className: "status c-destructive" },
  active: { label: "Active", className: "status c-success" },
} as const
export function ScheduleJobStatus({ job }: { job: ScheduledJob }) {
  const status = STATUS[scheduleJobStatus(job)]
  return (
    <span className={status.className}>
      <span className="dot" />

      {status.label}
    </span>
  )
}
